<template>
  <div class="section">
    <div style="height: 100%">
      <cargo-ag-grid
        no="3"
        config-module="150010"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <airline-product-voyage-board-dialog
      :visible.sync="voyageBoardDialog.visible"
      :row-data="voyageBoardDialog.rowData"
      @save="voyageBoardSaveHandle"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import { WEEKS } from '@/class/cargo/model/parameters/SystemConstants'
import { formatNumberToThousands } from '@/utils'
import { AirlineProductVoyage } from '@/class/model/booking/AirlineProductVoyage'
import airlineProductVoyageBoardDialog
  from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageBoardDialog'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor'
import { DocumentManage } from '@/utils/commonUtil'
import { YES_NO_TYPES } from '@/class/cargo/model/parameters/RadioStatusConstants'

export default {
  name: 'AirlineProductVoyage',
  components: { airlineProductVoyageBoardDialog },
  props: {
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      selectedItem: null,
      delVoyageKeys: [],
      delVoyageBoardKeys: [],
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor
        }
      },
      gridApi: null,
      columnDefs:
         [
           {
             headerName: this.$t('CargoMsg.Cargo_Valid'),
             field: 'active',
             cellRenderer: params => {
               const checkBoxClickHandler = this.documentManage.getPath('checkBoxClickHandler')
               return `<input type="checkbox" ${params.value ? `checked="checked"` : ``} onclick="${checkBoxClickHandler}(${params.data.voyage})" />`
             },
             width: 180
           }, {
             headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
             field: 'serialNumber',
             cellEditor: 'CargoAgGridCommonInputEditor',
             width: 100
           }, {
             headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
             field: 'voyage',
             valueFormatter: params => {
               return ColumnUtils.showTypeLabelFunc(params.value, WEEKS)
             },
             width: 100
           }, {
             headerName: this.$t('AirExport.FlightNumber'),
             field: 'flightNumber',
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             width: 100
           }, {
             headerName: this.$t('CargoMsg.Cargo_TransferPort') + '1',
             field: 'dischargingPort1',
             editable: true,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 selectType: TYPE_NAMES.basic_data_Airport,
                 filterable: true,
                 placeholder: ' ',
                 clearable: false,
                 // tagName: 'code'
                 tagName: 'chineseName',
                 customLabel: (item) => `${item.chineseName}`
               }
             },
             width: 180
           }, {
             headerName: this.$t('CargoMsg.Cargo_TransferPort') + '2',
             field: 'dischargingPort2',
             editable: true,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 selectType: TYPE_NAMES.basic_data_Airport,
                 filterable: true,
                 placeholder: ' ',
                 clearable: false,
                 tagName: 'code'
               }
             },
             width: 180
           }, {
             headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
             field: 'destinationPortCode',
             editable: true,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 selectType: TYPE_NAMES.basic_data_Airport,
                 filterable: true,
                 placeholder: ' ',
                 clearable: false,
                 tagName: 'code'
               }
             },
             width: 180
           }, {
             headerName: this.$t('CargoMsg.Cargo_TransshipmentPort'),
             field: 'transshipmentPortList',
             editable: true,
             cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
             cellEditorParams: {
               selectProps: {
                 multiple: true,
                 selectType: TYPE_NAMES.basic_data_Airport,
                 filterable: true,
                 placeholder: ' ',
                 clearable: true,
                 tagName: 'code'
               }
             },
             width: 180,
             onCellValueChanged: p => this.onCellChange(p)
           }, {
             headerName: this.$t('CargoMsg.Cargo_ApplicableContainerType'),
             field: 'airplaneContainerType',
             cellRenderer: params => {
               const buttonClickHandler = this.documentManage.getPath('buttonClickHandler')
               const label = ColumnUtils.getAirplaneContainerTypeLabel(params.data)
               return `<div>
                          <div style="display: inline-block;width: 80%">${label}</div>
                          <button style="border-radius: 2px" onclick="${buttonClickHandler}(${params.data.voyage})">
                              <i class="el-icon-edit">
                              </i>
                          </button>
                        </div>`
             },
             width: 100
           },
           {
             headerName: this.$t('CargoMsg.Cargo_BoardCount'),
             colId: 'limitLength',
             field: 'limitLength',
             width: 100,
             cellRenderer: params => {
               return ColumnUtils.getBoardCountLabel(params.data)
             }
           }, {
             headerName: this.$t('CargoMsg.Cargo_BaseWeight'),
             colId: 'basicWeight',
             field: 'basicWeight',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 3
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_LimitWeight'),
             colId: 'limitWeight',
             field: 'limitWeight',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 3
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_SellableSpace'),
             colId: 'availableCabinSpace',
             field: 'availableCabinSpace',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 3
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_LengthLimit'),
             colId: 'limitLength',
             field: 'limitLength',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 0
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_HeightLimit'),
             colId: 'limitHeight',
             field: 'limitHeight',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 0
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_TheoreticalVolume'),
             colId: 'theoryVolume',
             field: 'theoryVolume',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 3
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_SellableVolume'),
             colId: 'sellableVolume',
             field: 'sellableVolume',
             width: 100,
             valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
             editable: true,
             cellEditor: 'CargoAgGridCommonInputEditor',
             cellEditorParams: {
               isNumber: true,
               inputProps: {
                 precision: 3
               }
             }
           }
         ],
      voyageBoardDialog: {
        visible: false
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('checkBoxClickHandler', function(uid) {
      context.checkBoxClickHandler(uid)
    })
    this.documentManage.set('buttonClickHandler', function(uid) {
      context.buttonClickHandler(uid)
    })
  },
  methods: {
    voyageBoardSaveHandle(data) {
      this.delVoyageBoardKeys = [...this.delVoyageBoardKeys, ...data]
      this.$nextTick(() => {
        this.gridApi.refreshCells({ force: true })
      })
    },
    checkBoxClickHandler(voyage) {
      const row = this.rowData.find(row => row.voyage === voyage)
      row.active = !row.active
      if (!row.active) {
        if (row.uuid) {
          this.delVoyageKeys.push(row.uuid)
        }
        const airlineProductVoyage = new AirlineProductVoyage().fillDefaultValue().getData()
        airlineProductVoyage.voyage = row.voyage
        airlineProductVoyage.serialNumber = row.serialNumber
        airlineProductVoyage.voyageBoards = []
        airlineProductVoyage.voyageCosts = []
        airlineProductVoyage.transshipmentPortList = []
        Object.assign(row, airlineProductVoyage)
      }
      this.gridApi.refreshCells({ force: true })
    },
    buttonClickHandler(voyage) {
      const row = this.rowData.find(row => row.voyage === voyage)
      this.voyageBoardDialog.visible = true
      if (!row.voyageBoards || row.voyageBoards.length === 0) {
        row.voyageBoards = []
      }
      this.voyageBoardDialog.rowData = row.voyageBoards
    },
    // 保存前校验
    check() {
      for (const row of this.rowData) {
        if (row.active) {
          if (!row.destinationPortCode) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_DestinationPort'))
            return false
          }
        }
      }
      return true
    },
    // 列编辑修改事件
    onCellChange(params) {
      const { colDef } = params
      switch (colDef.field) {
        case 'transshipmentPortList':
          if (params.newValue && params.newValue.length > 0) {
            params.data.transshipmentPort = params.newValue.join(',')
          }
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
